"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSignatureString = exports.getNowString = exports.getBytesFromHex = exports.getAuthenticationHelper = void 0;
var getAuthenticationHelper_1 = require("./getAuthenticationHelper");
Object.defineProperty(exports, "getAuthenticationHelper", { enumerable: true, get: function () { return getAuthenticationHelper_1.getAuthenticationHelper; } });
var getBytesFromHex_1 = require("./getBytesFromHex");
Object.defineProperty(exports, "getBytesFromHex", { enumerable: true, get: function () { return getBytesFromHex_1.getBytesFromHex; } });
var getNowString_1 = require("./getNowString");
Object.defineProperty(exports, "getNowString", { enumerable: true, get: function () { return getNowString_1.getNowString; } });
var getSignatureString_1 = require("./getSignatureString");
Object.defineProperty(exports, "getSignatureString", { enumerable: true, get: function () { return getSignatureString_1.getSignatureString; } });
